var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.policy)?_c('div',{staticClass:"small-12 articleFeatureImage flex justify-center animated fadeIn"},[_c('picture',{staticClass:"small-12 float-left",style:(_vm.featureBackgroundImage)})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }